<template>
    <div style="display:none;">
        <div id="toesturenModal">
            <h2 style="text-align: center;">Stuur deze cruise per e-mail</h2>
            <form
                id="sendCruiseForm"
                enctype="application/x-www-form-urlencoded"
                method="post"
                action="javascript:toesturen('190009');"
            >
                <fieldset id="sendCruiseField">
                    <p>
                        Aan: <br />
                        <label for="">Naam:</label>
                        <input
                            id="sendCruiseToName"
                            class="required"
                            required=""
                            type="text"
                        />
                        <br />
                        <label for="">Email:</label>
                        <input
                            id="sendCruiseToEmail"
                            class="required email"
                            placeholder="E-mail ontvangen"
                            required=""
                            type="email"
                        />
                    </p>
                    <p>
                        Van: <br />
                        <label for="">Naam:</label>
                        <input
                            id="sendCruiseFromName"
                            class="required"
                            required=""
                            type="text"
                        />
                        <br />
                        <label for="">Email:</label>
                        <input
                            id="sendCruiseFromEmail"
                            class="required email"
                            placeholder="E-mail afzender"
                            required=""
                            type="email"
                        />
                        <br />
                        <input id="sendCruiseCopy" type="checkbox" /> Stuur mij
                        een kopie
                    </p>
                    <p>
                        Persoonlijke boodschap:
                        <textarea
                            id="sendCruiseMessage"
                            rows="4"
                            cols="45"
                        ></textarea>
                    </p>
                    <input
                        value="Versturen"
                        class="submitButton button"
                        type="submit"
                    />
                </fieldset>
            </form>
            <br />
            <p style="display: none;" id="sendCruiseSuccess">
                Deze cruise is naar dit e-mailadres verstuurd.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SendThisCruiseModal',
}
</script>

<style scoped></style>
